module.exports = __webpack_public_path__ + "static/Mobile-App-Developers-2020-award-1c995e6c25f5b49cbec8581065086e68.png";